import React from 'react';

import { Skeleton } from '@rbilabs/universal-components';
import { StyleSheet } from 'react-native';

import { Box } from 'components/ui';

export const OfferStatusContainerSkeleton = () => {
  return (
    <Box style={styles.container}>
      <Skeleton width="3/4" height="$3" rounded={12} marginBottom="$1" />
    </Box>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
  },
});
